import { Component, OnInit } from '@angular/core';
import { ExpedienteIcaDTO } from '../../../dto/expediente/expediente-ica.dto';
import { ActivatedRoute, Router } from '@angular/router';
import { ExpedienteService } from '../../../services/expediente.service';
import {ExpedienteSupersociedadesDto, ParteDTO} from '../../../dto/expediente/expediente-supersociedades.dto';
import moment from 'moment';
import { ExpedienteSicDto } from '../../../dto/expediente/expediente-sic.dto';
import { ExpedienteSupersaludDto } from '../../../dto/expediente/expediente-supersalud.dto';
import { ExpedienteSuperfinancieraDto } from '../../../dto/expediente/expediente-superfinanciera.dto';
import { ExpedienteDndaDto } from '../../../dto/expediente/expediente-dnda.dto';
import { ExpedienteDimarDto } from '../../../dto/expediente/expediente-dimar.dto';
import { ExpedienteSupersociedadesMercantilesDto } from '../../../dto/expediente/expediente-supersociedades-mercantiles.dto';
import {HistoricoSSIDTO} from "../supersociedades-insolvencia/models/expedienteSSIDTO";
import { Constants } from '../../../constants/constants';

@Component({
  selector: 'app-encabezado-expediente',
  templateUrl: './encabezado-expediente.component.html',
  styleUrl: './encabezado-expediente.component.scss',
})
export class EncabezadoExpedienteComponent implements OnInit {
  expedienteIcaDto?: ExpedienteIcaDTO;
  expedienteSupersociedadesDto?: ExpedienteSupersociedadesDto;
  expedienteInsolvenciaDto?: HistoricoSSIDTO;
  expedienteSICDto: ExpedienteSicDto = {};
  expedienteSupersaludDto: ExpedienteSupersaludDto = {};
  expedienteSuperfinancieraDto?: ExpedienteSuperfinancieraDto;
  expedienteDndaDto?: ExpedienteDndaDto;
  expedienteDimarDto: ExpedienteDimarDto = {};
  expedienteSupersociedadesMercantilesDto?: ExpedienteSupersociedadesMercantilesDto;

  tipoEntidad: number = 0;
  idExpediente: number = 0;
  numeroRadicado = 0;

  tipoEntidadNombre: string = '';
  tipoDocumentoUsuario = '';
  identificacionUsuario = '';
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private expedienteService: ExpedienteService
  ) {
    this.route.params.subscribe(params => {
      this.tipoEntidad = +params['entidadId'];
      this.idExpediente = params['expedienteId'];
      this.numeroRadicado = params['numeroRadicado'];
      this.tipoEntidadNombre = this.router.url.split('/')[2];
    });
    const infoInicioSesion = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) ?? '{}'
    );
    this.tipoDocumentoUsuario = infoInicioSesion.tipoDocumento;
    this.identificacionUsuario = infoInicioSesion.identificacion;
  }

  ngOnInit(): void {
    this.tipoExpedienteId(this.tipoEntidad, this.idExpediente);
    this.tipoExpedienteNombre(this.tipoEntidadNombre, this.idExpediente);
  }

  filtradoExpedienteSuperSociedades(idExpediente: number) {
    this.expedienteService
      .getExpedientesSupersociedades(idExpediente,this.tipoDocumentoUsuario,this.identificacionUsuario)
      .subscribe(response => {
        this.expedienteSupersociedadesDto = response;
        if (response.partes) {
          this.expedienteSupersociedadesDto.nombre_demandante = this.buscarNombre(response.partes, 'Demandante');
          this.expedienteSupersociedadesDto.nombre_demandado = this.buscarNombre(response.partes, 'Demandado');
        }
        // this.expedienteSupersociedadesDto.fechaCreacion = moment(
        //   response.fechaCreacion,
        //   'DD/MM/YYYY'
        // )
        //   .toDate()
        //   .toDateString();        // this.expedienteSupersociedadesDto.fechaCreacion = moment(
        //   response.fechaCreacion,
        //   'DD/MM/YYYY'
        // )
        //   .toDate()
        //   .toDateString();
        if (response.actuaciones){
          this.expedienteSupersociedadesDto.actuaciones.map(actuacion => {
            actuacion.fecha_carga_informacion = moment(
              actuacion.fecha_carga_informacion,
              'DD/MM/YYYY'
            ).toDate();
            actuacion.fecha_radicacion = moment(
              actuacion.fecha_radicacion,
              'DD/MM/YYYY'
            ).toDate();
          });
        }
      });
  }

  buscarNombre(partes: ParteDTO[], parte: string): string{
    const nombre = partes.find(p => p.parte === parte)?.nombre;
    return <string>nombre;
  }
  filtradoExpedienteSIC(idExpediente: number) {
    this.expedienteService.getExpedienteSic(idExpediente, this.tipoDocumentoUsuario, this.identificacionUsuario).subscribe({
      next: data => {
        this.expedienteSICDto = data;
      },
      error: err => {
        console.error('Error getting data', err);
      },
    });
  }

  filtradoExpedienteSupersalud(expedienteId: number) {
    this.expedienteService.getExpedienteSuperSalud(expedienteId,this.tipoDocumentoUsuario,this.identificacionUsuario).subscribe({
      next: data => {
        this.expedienteSupersaludDto = data;
      },
      error: err => {
        console.error('Error getting data', err);
      },
    });
  }

  filtradoExpedienteSuperfinanciera(idExpediente: number) {
    this.expedienteService
      .getExpedientesSuperfinanciera(idExpediente,this.tipoDocumentoUsuario,this.identificacionUsuario)
      .subscribe(response => {
        if (typeof response.fecha_creacion === 'string') {
          const fecha = new Date(response.fecha_creacion);
          if (!isNaN(fecha.getTime())) {
            response.fecha_creacion = fecha;
          } else {
            console.warn("Fecha inválida recibida:", response.fecha_creacion);
            response.fecha_creacion = undefined;
          }
        }
        this.expedienteSuperfinancieraDto = response;
      });
  }

  filtradoExpedienteDnda(idExpediente: number) {
    this.expedienteService
      .getExpedientesDnda(idExpediente)
      .subscribe(response => {
        this.expedienteDndaDto = response;
      });
  }

  filtradoExpedienteDimar(expedienteId: number) {
    this.expedienteService.getExpedienteDimar(expedienteId,this.tipoDocumentoUsuario,this.identificacionUsuario).subscribe({
      next: data => {
        this.expedienteDimarDto = this.formatDates(data);
      },
      error: err => {
        console.error('Error getting data', err);
      },
    });
  }

  filtradoExpedienteIca(idExpediente: number) {
    this.expedienteService
      .getExpedientesIca(idExpediente)
      .subscribe(response => {
        this.expedienteIcaDto = response;
      });
  }

  filtradoExpedienteSupersociedadesM(idEntidad: number) {
    this.expedienteService
      .getExpedienteSupersociedadesMercantiles(idEntidad,this.tipoDocumentoUsuario,this.identificacionUsuario)
      .subscribe(response => {
        this.expedienteSupersociedadesMercantilesDto = response;
      });
  }

  filtrarExpedienteSSI(id: number){
    this.expedienteService.detalleSSI(id).subscribe((resp: HistoricoSSIDTO[]) => {
      this.expedienteInsolvenciaDto = resp[0];
    });
  }
  tipoExpedienteId(idEntidad: number, idExpediente: number) {
    switch (idEntidad) {
      case 1:
        this.filtradoExpedienteSuperSociedades(idExpediente);
        break;
      case 2:
        this.filtradoExpedienteSIC(idExpediente);
        break;
      case 3:
        this.filtradoExpedienteSupersalud(idExpediente);
        break;
      case 4:
        this.filtradoExpedienteSuperfinanciera(idExpediente);
        break;
      case 5:
        this.filtradoExpedienteDnda(idExpediente);
        break;
      case 6:
        this.filtradoExpedienteDimar(idExpediente);
        break;
      case 7:
        this.filtradoExpedienteIca(idExpediente);
        break;
      case 8:
        this.filtradoExpedienteSupersociedadesM(idExpediente);
        break;
    }
  }

  tipoExpedienteNombre(nombreEntidad: string, idExpediente: number) {
    switch (nombreEntidad) {
      case 'supersociedades':
        this.filtradoExpedienteSuperSociedades(idExpediente);
        break;
      case 'sic':
        this.filtradoExpedienteSIC(idExpediente);
        break;
      case 'supersalud':
        this.filtradoExpedienteSupersalud(idExpediente);
        break;
      case 'superfinanciera':
        this.filtradoExpedienteSuperfinanciera(idExpediente);
        break;
      case 'dnda':
        this.filtradoExpedienteDnda(idExpediente);
        break;
      case 'dimar':
        this.filtradoExpedienteDimar(idExpediente);
        break;
      case 'ica':
        this.filtradoExpedienteIca(idExpediente);
        break;
      case 'ssm':
        this.filtradoExpedienteSupersociedadesM(idExpediente);
        break;
      case 'ssi':
        this.filtrarExpedienteSSI(idExpediente);
    }
  }

  formatDates(data: ExpedienteDimarDto): ExpedienteDimarDto {
    let fechaCreacion;
    data.actuaciones?.map(item => {
      item.fecha_actuacion = moment(item.fecha_actuacion).format('YYYY-MM-DD');
      item.fecha_registro = moment(item.fecha_registro).format('YYYY-MM-DD');
      fechaCreacion = moment(item.fecha_registro).format('YYYY-MM-DD');
    });

    data.fecha_creacion = fechaCreacion
    return data;
  }
}
